export default __webpack_public_path__ + "static/media/sectionOne.5cb4ce2f.jpg";